import { Box, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'

import { RenderTooltip } from '../../../../../components/utilities/RenderTooltip'

import styles from './styles.module.scss'
import { useMemo } from 'react'

const renderDate = (obj) => {
  return `${obj.day}/${obj.month}/${obj.year}`
}

const processField = (data) => {
  if (!data) return '---'
  if (Array.isArray(data)) return data.join(' ')
  if (typeof data === 'object') return renderDate(data)
  return data
}

const CheckLegalDocuments = ({ data }) => {
  const { t } = useTranslation(['common', 'messages'])

  const getDocumentNumberLabel = (issuingCountry, t) => {
    switch (issuingCountry) {
      case 'AR':
        return t('common:cuilCuit')
      case 'BR':
        return t('common:cpf')
      default:
        return t('common:documentNumber')
    }
  }

  const getFieldLabel = (field, data) => {
    if (field === 'controlNumber') {
      const issuingCountry = data?.result?.breakdown?.extractedData?.allExtractedData?.visual?.issuingCountry ||
                           data?.result?.breakdown?.extractedData?.allExtractedData?.mrz?.issuingCountry ||
                           data?.result?.breakdown?.extractedData?.allExtractedData?.barcode?.issuingCountry ||
                           data?.result?.breakdown?.extractedData?.documentDetails?.issuingCountry
      
      return getDocumentNumberLabel(issuingCountry, t)
    }
    
    return t(`messages:kyc.check.legalDocuments.${field}`)
  }

  const checkLegalDocuments = useMemo(() => {
    if (data?.result?.breakdown?.extractedData?.allExtractedData) {
      const { visual, mrz, barcode } = data.result.breakdown.extractedData.allExtractedData
      const showAttributes = visual || mrz || {}

      const fields = Object.keys(showAttributes)

      return fields.map((field) => {
        return {
          field: field,
          ...(visual && { visual: visual[field] }),
          ...(mrz && { mrz: mrz[field] }),
          ...(barcode && { barcode: barcode[field] }),
        }
      })
    }

    return null
  }, [data])

  if (!checkLegalDocuments) return null

  return (
    <TableContainer>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>{t('common:field')}</TableCell>
            <TableCell>
              <Box className={styles.tableTitle}>
                {t('common:visual')}

                <RenderTooltip title={t('messages:kyc.check.visual.tooltip')} />
              </Box>
            </TableCell>
            <TableCell>
              <Box className={styles.tableTitle}>
                MRZ
                <RenderTooltip title={t('messages:kyc.check.mrz.tooltip')} />
              </Box>
            </TableCell>
            <TableCell>
              <Box className={styles.tableTitle}>
                {t('common:barcode')}

                <RenderTooltip title={t('messages:kyc.check.barcode.tooltip')} />
              </Box>
            </TableCell>
          </TableRow>
        </TableHead>

        <TableBody>
          {checkLegalDocuments.map((item) => (
            <TableRow key={item.field}>
              <TableCell>{getFieldLabel(item.field, data)}</TableCell>
              <TableCell>{processField(item.visual)}</TableCell>
              <TableCell>{processField(item.mrz)}</TableCell>
              <TableCell>{processField(item.barcode)}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  )
}

export default CheckLegalDocuments
